module.exports = __webpack_public_path__ + "560cb25c4748868834f3cf20ae0686c9.png";